import { useState } from "react";
import { Button } from "react-bootstrap";

type TruncatedTextProps = {
  text: string;
  maxLength?: number;
  showButton?: boolean;
  className?: string;
};

export function TruncatedText({ text, maxLength = 90, className, showButton = true }: TruncatedTextProps) {
  const [showFull, setShowFull] = useState(false);
  const shouldTruncate = text.length > maxLength;
  const displayText = !showFull && shouldTruncate 
    ? `${text.substring(0, maxLength)}...` 
    : text;

  return (
    <>
      <span className={className}>{displayText}</span>
      {shouldTruncate && showButton && (
        <Button
          variant="link"
          size="sm"
          className="p-0 text-decoration-none align-self-start d-block"
          onClick={() => setShowFull(!showFull)}
        >
          {showFull ? 'Show less' : 'Show more'}
        </Button>
      )}
    </>
  );
}